import IQueries from "@/interfaces/IQueries";

// Path with parameters
const statisticsReports: IQueries = {
  fetchStatisticsReports: {
    path: "/main/statistics_reports",
    method: "GET",
  },
  fetchStatisticsReport: {
    path: "/main/statistics_reports/",
    method: "GET",
  },
  createStatisticsReport: {
    path: "/main/statistics_reports",
    method: "POST",
  },
  updateStatisticsReport: {
    path: "/main/statistics_reports/",
    method: "PUT",
  },
};

export default statisticsReports;
